import React from "react";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const formatSecondsAsDuration = (seconds) => {
    const secs = Math.round(Number(seconds)) || 0;
    const minutes = Math.floor(secs / 60);
    const remainingSecs = secs % 60;
    if (minutes > 0) {
        return `${minutes}m ${remainingSecs}s`;
    }
    return `${remainingSecs}s`;
};

const ColumnChart = ({ data, name, xAxisLabel = 'Visits', yAxisLabel = 'Visits', tooltipSuffix = 'Visits', formatTooltipAsDuration = false, sortDescending = false, sortAscending = false }) => {
    const graphColors = ['#a1c1e0', '#C1C1C1', '#AD6ca5', '#787878', '#701540'];

    let sortedData = data;
    if (sortDescending && data) {
        sortedData = [...data].sort((a, b) => (b?.[name ?? 'hits'] || 0) - (a?.[name ?? 'hits'] || 0));
    } else if (sortAscending && data) {
        sortedData = [...data].sort((a, b) => (a?.[name ?? 'hits'] || 0) - (b?.[name ?? 'hits'] || 0));
    }

    const graphData = sortedData?.map((item, index) => ({
        y: item?.[name ?? 'hits'],
        color: graphColors[index % graphColors.length],
    }));
    const categories = sortedData?.map((item, idx) => item?.page ?? item?.y ?? `Visit ${idx + 1}`);

    const columnOptions = {
        chart: {
            type: 'column',
        },
        title: {
            text: '',
        },
        tooltip: (function () {
            return formatTooltipAsDuration
                ? {
                    formatter: function () {
                        const pageLabel = this.point.category || this.x;
                        return `<b>Page ${pageLabel}</b><br/>${formatSecondsAsDuration(this.point.y)}`;
                    },
                }
                : {
                    formatter: function () {
                        const pageLabel = this.point.category || this.x;
                        return `<b>Page ${pageLabel}</b><br/>${this.point.y} ${tooltipSuffix}`;
                    },
                };
        })(),
        xAxis: {
            categories: categories, // Set categories for x-axis
            title: {
                text: xAxisLabel,
            },
        },
        yAxis: {
            title: {
                text: yAxisLabel,
            },
            labels: {
                formatter: function () {
                    return this.value;
                },
            },
        },
        legend: {
            enabled: false, // Hides the legend
        },
        series: [
            {
                name: name,
                data: graphData,
            },
        ],
    };

    if (!data || data.length === 0) {
        return <p className="text-center text-muted py-5">No pages with matching criteria</p>;
    }

    return (
        <>
            <HighchartsReact highcharts={Highcharts} options={columnOptions} />
        </>
    );
};

export default ColumnChart;